import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const initialState = {
  name: '',
  description: '',
  quantity: '',
  unit: '',

  reorder_level: '',
  expiry_date: '',
  supplier: '',
};

const LabSupplyEditor = ({
  onSubmit,
  submitting,
  onCancel,
  isEditing,
  initialData,
}) => {
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState(null);

  useEffect(() => {
    if (initialData) {
      const picked = {};
      Object.keys(initialState).forEach((key) => {
        picked[key] = initialData[key] !== undefined ? initialData[key] : '';
      });
      setForm((prev) => ({ ...prev, ...picked }));
    }
  }, [initialData]);

  const handleDateChange = (date) => {
    setForm((prev) => ({
      ...prev,
      expiry_date: date ? date.toISOString().split('T')[0] : '',
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name.trim()) {
      setFormError('Supply name is required.');
      return;
    }

    setFormError(null);

    onSubmit({
      ...form,
      quantity: form.quantity ? Number(form.quantity) : null,

      reorder_level: form.reorder_level ? Number(form.reorder_level) : null,
    });
    setForm(initialState);
  };

  return (
    <div className="add inventory-editor space-y-4">
      <h3 className="user-form-heading text-lg font-semibold">
        {isEditing ? 'Edit Lab Supply' : 'Add New Lab Supply'}
      </h3>

      {formError && (
        <div className="error-msg">
          {formError}
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 sm:grid-cols-2 gap-2"
      >
        <div className="flex flex-col gap-[10px]">
          <label htmlFor="name" className="text-sm font-medium">
            Supply Name
          </label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Supply Name"
            className="border p-2 rounded"
            required
          />
        </div>

        <div className="flex flex-col gap-[10px]">
          <label htmlFor="unit" className="text-sm font-medium">
            Unit
          </label>
          <input
            name="unit"
            value={form.unit}
            onChange={handleChange}
            placeholder="e.g., pieces, ml, boxes"
            className="border p-2 rounded"
          />
        </div>

        <div className="flex flex-col gap-[10px]">
          <label htmlFor="quantity" className="text-sm font-medium">
            Quantity
          </label>
          <input
            type="number"
            name="quantity"
            value={form.quantity}
            onChange={handleChange}
            placeholder="Quantity"
            className="border p-2 rounded"
            required
          />
        </div>

        <div className="flex flex-col gap-[10px]">
          <label htmlFor="reorder_level" className="text-sm font-medium">
            Reorder Level
          </label>
          <input
            type="number"
            name="reorder_level"
            value={form.reorder_level}
            onChange={handleChange}
            placeholder="Reorder Level"
            className="border p-2 rounded"
          />
        </div>

        <div className="flex flex-col gap-[10px]">
          <label htmlFor="supplier" className="text-sm font-medium">
            Supplier
          </label>
          <input
            name="supplier"
            value={form.supplier}
            onChange={handleChange}
            placeholder="Supplier name"
            className="border p-2 rounded"
          />
        </div>

        <div className="flex flex-col gap-[10px]">
          <label htmlFor="expiry_date" className="text-sm text-gray-700 mb-1">
            Expiry Date
          </label>
          <DatePicker
            selected={form.expiry_date ? new Date(form.expiry_date) : null}
            onChange={handleDateChange}
            className="border p-2 rounded"
            placeholderText="Select expiry date"
          />
        </div>

        <textarea
          name="description"
          value={form.description}
          onChange={handleChange}
          placeholder="Description (optional)"
          className="border p-2 rounded col-span-2"
        />

        <div className="flex justify-around gap-2 col-span-2 mt-2">
          <button
            type="submit"
            className="primary"
            disabled={submitting}
          >
            {submitting
              ? 'Saving...'
              : isEditing
                ? 'Update Supply'
                : 'Add Supply'}
          </button>

          <button
            type="button"
            onClick={onCancel}
            className="secondary"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

LabSupplyEditor.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  initialData: PropTypes.object,
};

export default LabSupplyEditor;
